import React, { Fragment } from "react";
import Typography from "@material-ui/core/Typography";

const NotFoundPage = () => {
  return (
    <Fragment>
      <Typography variant="h1" component="h2">
        Not Found
      </Typography>
    </Fragment>
  );
};

export default NotFoundPage;
